import { isNil, propOr } from 'ramda';
import useNiveauxGarantiesTarifsPrevTnsRenteConjointForm
  from '../hooks/useNiveauxGarantiesTarifsPrevTnsRenteConjointForm';
import { ControlledRadioButton, ControlledSwitch } from '@@viewCommonComponents/controlled';
import { Collapse, ReimbursementChart, SectionTitle, TotalTable } from '@fasstech/middle-design-system';
import mapOfferNodeOptions from '@@viewHelpers/mapOfferNodeOptions';
import AddGrantee from './AddGrantee.jsx';
import extraMadelin from '../extra/extraMadelin.js';

const NiveauxGarantiesTarifsPrevTnsRenteConjointForm = ({
  form,
  guarantees,
  getMiddleNumber,
  getMiddleText,
  annualIncome
}) => {
  const {
    rConj,
    minSpouseAge,
    maxSpouseAge,
    minSpouseBirthDate,
    maxSpouseBirthDate,
    spouse,
    addSpouse,
    setEditingSpouse,
    deleteSpouse,
    isSpouseRequired,
    isRenteConjointRequired,
    OPTION_RCONJ,
    RCONJ_MAD,
    renteConjointCotisation,
    rconjHealthInsurances,
    rentConjReimbursementGraphContent
  } = useNiveauxGarantiesTarifsPrevTnsRenteConjointForm({
    form,
    guarantees,
    getMiddleNumber,
    getMiddleText,
    annualIncome
  });

  return (
    <Collapse title={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_RCONJ_LABEL')}>
      <div className="flex gap-10 flex-col-reverse md:flex-row">
        {/*Left column*/}
        <div className="flex-1">
          <div className="flex-1">
            {OPTION_RCONJ && (
              <ControlledSwitch
                name="guarantees.OPTION_RCONJ.selected"
                label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_RCONJ_CHOIX_LABEL')}
                labelClassNames="text-lg"
                rules={isSpouseRequired(spouse)}
                disabled={!OPTION_RCONJ.editable}
                displayError={false}
                form={form}
                recommended={OPTION_RCONJ.recommended}
                infoMessage={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_RCONJ_MESSAGE_INFO')}
                data-testid="OPTION_RCONJ"
              />
            )}
          </div>

          {rConj && (
            <>
              <div className="flex flex-row">
                <div className="w-2/3">
                  <AddGrantee
                    title={'Conjoint'}
                    buttonTitle={'Ajouter un conjoint'}
                    icon={'user'}
                    infoTooltip={getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_AGE_SPOUSE_INFO', {
                      minGranteeAge: minSpouseAge,
                      maxGranteeAge: maxSpouseAge
                    })}
                    grantees={[spouse]}
                    addGrantee={addSpouse}
                    deleteGrantee={deleteSpouse}
                    setEditingGrantee={setEditingSpouse}
                    granteeHasBirthDate={form.watch('spouse.birthDate')}
                    form={form}
                    minBirthDate={minSpouseBirthDate}
                    maxBirthDate={maxSpouseBirthDate}
                    isMaxCountReached={!isNil(spouse)}
                    maxCountMessage={''}
                    formName={'spouse'}
                    dataTestId={'spouse'}
                    getMiddleText={getMiddleText}
                  />
                </div>
                <div className="w-1/3">
                  <ReimbursementChart
                    healthInsurances={rconjHealthInsurances}
                    labels={propOr([], 'labelsRO', guarantees.RCONJ_CAP)}
                    ROs={propOr([], 'RO', guarantees.RCONJ_CAP)}
                    displayGraph
                    rows={rentConjReimbursementGraphContent.rows}
                    note={rentConjReimbursementGraphContent.note}
                  />
                </div>

              </div>
              <div className="flex-1">
                <hr class="mt-8 mb-6"/>

                <SectionTitle>
                  {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_RCONJ_CAPITAL_LABEL')}
                </SectionTitle>
                <div>
                  <ControlledRadioButton
                    withIndicator={false}
                    isMultiline
                    isResponsiveCol
                    form={form}
                    name="guarantees.RCONJ_CAP.value"
                    options={mapOfferNodeOptions(guarantees.RCONJ_CAP)}
                    rules={isRenteConjointRequired}
                    data-testid="RCONJ_CAP"
                  />
                </div>
                <p className="mb-4">RA : Revenu annuel</p>

                {RCONJ_MAD && (
                  <ControlledSwitch
                    extraClick={() => extraMadelin(RCONJ_MAD.selected, form)}
                    name="guarantees.RCONJ_MAD.selected"
                    label={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_RCONJ_FISCA_MADELIN_LABEL'
                    )}
                    disabled={!RCONJ_MAD.editable}
                    containerClassName="mb-8"
                    labelClassNames="text-lg"
                    displayError={false}
                    form={form}
                    data-testid="RCONJ_MAD"
                  />
                )}

                <TotalTable rows={renteConjointCotisation}/>
              </div>
            </>
          )}
        </div>
      </div>
    </Collapse>
  );
};
export default NiveauxGarantiesTarifsPrevTnsRenteConjointForm;
